const formatTime = (seconds) => {
  if (!Number.isFinite(seconds)) return "0:00";

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

const initializeBlogAudioPlayer = () => {
  const player = document.querySelector("[data-blog-audio-player]");
  if (!player || player.dataset.initialized === "true") return;

  player.dataset.initialized = "true";

  const audio = player.querySelector("[data-blog-audio]");
  const openButton = document.querySelector("[data-blog-audio-open]");
  const playButton = player.querySelector("[data-blog-audio-play]");
  const seek = player.querySelector("[data-blog-audio-seek]");
  const currentTime = player.querySelector("[data-blog-audio-current]");
  const duration = player.querySelector("[data-blog-audio-duration]");
  const speedButton = player.querySelector("[data-blog-audio-speed]");
  const muteButton = player.querySelector("[data-blog-audio-mute]");
  const closeButton = player.querySelector("[data-blog-audio-close]");
  const speeds = [1, 1.25, 1.5, 2];

  const setPlayingState = (playing) => {
    playButton.setAttribute("aria-label", playing ? "Pozastavit" : "Přehrát");
    playButton.classList.toggle("is-playing", playing);
  };

  const updateTimeline = () => {
    seek.value = audio.currentTime;
    currentTime.textContent = formatTime(audio.currentTime);
    const progress = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
    seek.style.setProperty("--audio-progress", `${progress}%`);
  };

  const openPlayer = () => {
    player.hidden = false;
    document.body.classList.add("blog-audio-player-open");
    playButton.focus();
    audio.play().catch(() => setPlayingState(false));
  };

  const closePlayer = (restoreFocus = true) => {
    audio.pause();
    player.hidden = true;
    document.body.classList.remove("blog-audio-player-open");
    if (restoreFocus) openButton.focus();
  };

  openButton.addEventListener("click", openPlayer);
  playButton.addEventListener("click", () => {
    if (audio.paused) {
      audio.play().catch(() => setPlayingState(false));
    } else {
      audio.pause();
    }
  });
  closeButton.addEventListener("click", () => closePlayer());

  player.querySelectorAll("[data-blog-audio-skip]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = audio.currentTime + Number(button.dataset.blogAudioSkip);
      audio.currentTime = Math.max(0, Math.min(target, audio.duration || target));
    });
  });

  speedButton.addEventListener("click", () => {
    const nextIndex = (speeds.indexOf(audio.playbackRate) + 1) % speeds.length;
    audio.playbackRate = speeds[nextIndex];
    speedButton.textContent = `${audio.playbackRate}×`;
  });

  muteButton.addEventListener("click", () => {
    audio.muted = !audio.muted;
    muteButton.setAttribute("aria-label", audio.muted ? "Zapnout zvuk" : "Ztlumit");
    muteButton.classList.toggle("is-muted", audio.muted);
  });

  seek.addEventListener("input", () => {
    audio.currentTime = Number(seek.value);
    updateTimeline();
  });

  const updateMetadata = () => {
    seek.max = audio.duration;
    duration.textContent = formatTime(audio.duration);
    updateTimeline();
  };

  audio.addEventListener("loadedmetadata", updateMetadata);
  audio.addEventListener("timeupdate", updateTimeline);
  audio.addEventListener("play", () => setPlayingState(true));
  audio.addEventListener("pause", () => setPlayingState(false));
  audio.addEventListener("ended", () => setPlayingState(false));

  if (audio.readyState >= 1) updateMetadata();

  player.closeBlogAudioPlayer = () => closePlayer(false);
  document.getElementById("blog-post-detail").classList.add("blog-audio-enhanced");
};

document.addEventListener("turbolinks:load", initializeBlogAudioPlayer);
document.addEventListener("turbolinks:before-cache", () => {
  const player = document.querySelector("[data-blog-audio-player]");
  if (!player) return;

  if (player.closeBlogAudioPlayer) player.closeBlogAudioPlayer();
  delete player.dataset.initialized;
  document.getElementById("blog-post-detail").classList.remove("blog-audio-enhanced");
});
